import { LeftOutlined } from "@ant-design/icons";
import { Typography } from "antd";

export default function PageContainer({ title, backable, extra, children }) {
  return (
    <div className="p-6">
      <div className="flex items-center justify-start mb-6">
        {backable && (
          <div className="mr-2 w-6 h-6 rounded-md border border-gray-300 border-solid flex items-center justify-center bg-white">
            <LeftOutlined onClick={() => history.back()} className="text-xs"/>
          </div>
        )}
        <Typography.Title level={4} className="!m-0">{title}</Typography.Title>
        {extra && <div className="absolute right-6">{extra}</div>}
      </div>
      {children}
    </div>
  );
}
